<template>
  <v-dialog
    v-model="changeReferrerDialog"
    width="500"
    overlay-color="rgba(39, 50, 64)"
    overlay-opacity="0.6"
    :fullscreen="$vuetify.breakpoint.xs ? true : false"
    persistent
    :transition="false"
  >
    <v-card>
      <v-card-title
        class="header"
        primary-title
      >
        <b>{{ $t('users.changeReferrer') }}</b>
      </v-card-title>
      
      <v-card-text class="mt-2">
        <b>{{ user.name }}</b><br>
        {{ user.email }}
        <v-flex
          xs12
          mt-5
          mb-5
        >
          <v-autocomplete
            v-model.trim="form.referrer_uuid"
            :loading="loading"
            :search-input.sync="params.search"
            :items="whiteLabelUsers ? whiteLabelUsers.data : []"
            :item-text="'email'"
            :item-value="'uuid'"
            :error-messages="UserUuidErrors"
            :label="$t('users.newReferrerEmail')+'*'"
            required
            @blur="$v.form.referrer_uuid.$touch()"
          >
            <template v-slot:no-data>
              <small class="ml-3">{{ $t('globals.noData') }}</small>
            </template>
            <template
              slot="item"
              slot-scope="data"
            >
              <v-list-item-content>
                <v-list-item-title v-html="data.item.name" />
                <small class="text-neutral">{{ data.item.email }}</small>
              </v-list-item-content>
            </template>
          </v-autocomplete>
        </v-flex>
      </v-card-text>
      <v-divider />
     
      <v-card-actions>
        <v-spacer />
        <v-btn
          text
          :disabled="loading"
          @click="changeReferrerDialog = false"
        >
          <span>{{ $t('globals.cancelButton') }}</span>
        </v-btn>
        <v-btn
          color="primary"
          :disabled="loading || ($v.$invalid)"
          :loading="loading"
          @click="changeReferrer()"
        >
          {{ $t('globals.changeButton') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";

import WHITELABEL_USERS_QUERY from '@/graphql/queries/WhiteLabelUsersForInvoice.gql';
import CHANGE_REFERRER_MUTATION from "@/graphql/mutations/WhiteLabelChangeUserReferrer.gql";


import { validationMixin } from "vuelidate"
import { required } from 'vuelidate/lib/validators';

export default {
  name: "ChangeReferrerDialog",
  mixins: [validationMixin],
  props: {
    whitelabelUuid: {
      type: String,
      default() {
        return null;
      }
    },
    user: {
      type: Object,
      default() {
        return null;
      }
    },
    showDialog: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      itemsCount: 1,
      loading: false,
      params: {
        search: "",
        whitelabel_uuid: this.whitelabelUuid,
        page: 1,
        count: 25
      },
      form: {
        referrer_uuid: null,
      }
    };
  },
  computed: {
    ...mapGetters("whitelabel", ["getWhiteLabel"]),
    changeReferrerDialog: {
      get() {
        return this.showDialog;
      },
      set(val) {
        this.$emit('closeChangeReferrerDialog', false);
      }
    },
    rules() {
      var form = {
        referrer_uuid: {
          required,
        },
      };
      return form;
    },
    UserUuidErrors() {
      const errors = [];
      if (!this.$v.form.referrer_uuid.$dirty) return errors;
      !this.$v.form.referrer_uuid.required && errors.push(this.$t("projects.reqField"));
      return errors;
    },
  },
  watch: {
    params: {
      handler(val){
        if (val.search && val.search.length > 2) {
          this.$apollo.queries.whiteLabelUsers.refresh()
        }
      },
      deep: true
    }
  },
  validations() {
    return {
      form: this.rules
    };
  },
  methods: {
    changeReferrer() {
      this.$v.$touch()
      if (this.$v.$invalid) {
        return
      }
      const params = {
        user_uuid: this.user.uuid,
        referrer_uuid: this.form.referrer_uuid,
        whitelabel_uuid: this.getWhiteLabel.uuid
      }
      this.$apollo
        .mutate({
          mutation: CHANGE_REFERRER_MUTATION,
          variables: params
        })
        .then(data => {
          this.loading = false;
          this.$emit('closeChangeReferrerDialog', true);
        })
        .catch(error => {
          this.loading = false;
          if (error.graphQLErrors[0].extensions.category == 'authorization' && error.graphQLErrors[0].message === "This action is unauthorized.") {
            this.$store.commit("app/setShowPermission");
            return;
          }
          this.errorHandler(error);
        });
    }
  },
  apollo: {
    whiteLabelUsers: {
      query: WHITELABEL_USERS_QUERY,
      fetchPolicy: 'network-only',
      variables() {
        return this.params
      },
      skip() {
        return !this.whitelabelUuid || !this.params.search  || this.params.search.length < 2
      }
    },
  }
};
</script>

<style lang="scss" >
</style>
